import React from 'react';
import { Share2 } from 'lucide-react';
import { classNames } from '../../utils/classNames';
import { Tooltip } from '../../components/ui/Tooltip';
import { useI18n } from '../../hooks/useI18n';

export const ShareConversationButton = ({ disabled = false, onClick }) => {
  const { t } = useI18n();

  return (
    <Tooltip content={t('shareConversationTooltip')} position="bottom" align="end">
      <button
        type="button"
        disabled={disabled}
        aria-label={t('shareConversationTooltip')}
        onClick={onClick}
        className={classNames(
          'inline-flex h-9 w-9 items-center justify-center rounded-full border border-transparent text-neutral-600 transition',
          'hover:bg-neutral-100 hover:text-neutral-900 disabled:cursor-not-allowed disabled:opacity-50',
          'dark:text-muted dark:hover:bg-accent-soft dark:hover:text-text'
        )}
      >
        <Share2 size={18} aria-hidden />
      </button>
    </Tooltip>
  );
};
